import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'lodash/fp';
import { StackItem, withBreakpointRange } from '@optimus-web/core';
import {
    ContentContainer,
    isMobileOrTablet,
    LargeContentContainer,
    OverlayedLoader,
    SmallContentContainer,
} from '@mews-commander/ui';
import { getAllSteps } from '../selectors/steps';
import { isFetching as isBuilderFetching } from '../selectors/meta';
import stepMap from '../stepMap';
import EnterpriseBuilderScreenStep from '../EnterpriseBuilderScreenStep';
import { MenuViewWrapper, RightBodyWrapper } from './style';
import EnterpriseBuilderSidebar from './EnterpriseBuilderSidebar';

const EnterpriseBuilder = ({ breakpointRange, steps, isFetching }: $TSFixMe) => {
    const { currentStep } = steps;

    // @ts-expect-error $TSFixMeError: Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ Dashboard: { compon...
    const StepComponent = stepMap[currentStep].component;

    const stacked = isMobileOrTablet(breakpointRange);

    let ContentContainerComponent;
    if (stacked) {
        ContentContainerComponent = ContentContainer;
    } else if (currentStep === EnterpriseBuilderScreenStep.ResourceOverviewGrid) {
        ContentContainerComponent = LargeContentContainer;
    } else {
        ContentContainerComponent = SmallContentContainer;
    }

    return (
        <MenuViewWrapper stacked={stacked}>
            <EnterpriseBuilderSidebar />
            <RightBodyWrapper>
                <StackItem>
                    <ContentContainerComponent align="left">
                        {/* @ts-expect-error $TSFixMeError: Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ Dashboard: { compon... */}
                        <StepComponent scope={stepMap[currentStep].scope} />
                    </ContentContainerComponent>
                </StackItem>
                <OverlayedLoader show={isFetching} />
            </RightBodyWrapper>
        </MenuViewWrapper>
    );
};

export default compose(
    connect(
        createStructuredSelector({
            steps: getAllSteps,
            isFetching: isBuilderFetching,
        })
    ),
    // @ts-expect-error $TSFixMeError: No overload matches this call.
    withBreakpointRange
    // @ts-expect-error $TSFixMeError: Expected 0 arguments, but got 1.
)(EnterpriseBuilder);
